export const defaultGenders = [
  {
    value: 'male',
    label: 'мужчины',
  },
  {
    value: 'female',
    label: 'женщины',
  },
]